// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"209":"35506757","452":"b64a2167","649":"779f8557","744":"9c304ab7"}[chunkId] + ".chunk.js";
};